import * as Sentry from "@sentry/react";
import axios from "axios";
import { useEffect, useState } from "react";

import { APIEndpoints } from "@/apis/endpoints";

export enum GmailServiceAccountStatus {
  UNKNOWN,
  AVAILABLE,
  UNAVAILABLE,
}

export function useServiceAccountStatus(): GmailServiceAccountStatus {
  const [status, setStatus] = useState<GmailServiceAccountStatus>(
    GmailServiceAccountStatus.UNKNOWN,
  );

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const response = await axios.get(
          APIEndpoints.SIMULATION + "/users/sync/gsuite/key_status",
        );
        if (mounted) {
          setStatus(
            response.data.exists === true
              ? GmailServiceAccountStatus.AVAILABLE
              : GmailServiceAccountStatus.UNAVAILABLE,
          );
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [status]);

  return status;
}
